import type { EmployeeViewModelWithName } from '../../types';

import type { ListSectionItemInput } from '../../../library/lists/listSectionItemInput';

export function employeesAsListItems(
  hrefPrefix: string,
  employees: EmployeeViewModelWithName[],
): ListSectionItemInput[] {
  return employees.map((employee) => {
    let href = hrefPrefix + 'employees/' + employee.uuid;
    if (!employee.isConfirmedEntity) {
      href += '?edit';
    }
    return {
      label: employee.name,
      href,
      accessible: true,
      hasDraft: employee.hasDraft,
    };
  });
}
